// On a free workspace the only assignable diagram-share role is `member`
// (the backend `edit` role). Pro/Max workspaces may assign any role.
// export const FREE_SHARE_ROLE = 'member';
export const FREE_SHARE_ROLE = 'edit';

export function isShareRoleAllowed(plan, role) {
    const isPaid = (plan || 'free') !== 'free';
    if (isPaid) return true;
    return role === FREE_SHARE_ROLE;
}
